import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const useAppointmentRealtime = (userId, onAppointmentChange) => {
  useEffect(() => {
    if (!userId || !supabase) return;

    const channel = supabase?.channel('appointments-realtime')?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'appointments',
          filter: `user_id=eq.${userId}`
        },
        (payload) => {
          if (payload?.eventType === 'INSERT') {
            onAppointmentChange?.('INSERT', payload?.new);
          } else if (payload?.eventType === 'UPDATE') {
            onAppointmentChange?.('UPDATE', payload?.new);
          } else if (payload?.eventType === 'DELETE') {
            onAppointmentChange?.('DELETE', payload?.old);
          }
        }
      )?.subscribe();

    return () => {
      supabase?.removeChannel(channel);
    };
  }, [userId, onAppointmentChange]);
};

export default useAppointmentRealtime;